import underline from "../media/pen-underline.png"
import Nav from "../components/nav";
import { useState } from "react";
import FooterComp from "../components/footer";
import { Icon } from "@iconify/react";
import "aos/dist/aos.css";
import Fonav from "../components/fonnav";
import "../css/practice.css"
import { useNavigate } from "react-router-dom";
import useGenStore from "../store/store";
function Practice() {
  const [activeIndex, setActiveIndex] = useState(null);
  const menuActive = useGenStore((s)=>s.menuActive)
  const toggleFAQ = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const faqs = [
   {
  question: "Employment Law",
  number: "01",
  content: (
    <>
      <p><strong>Employee-side Representation:</strong></p>
      <ul>
        <li>Discipline</li>
        <li>Wrongful Termination</li>
        <li>Class Actions Lawsuits</li>
        <li>Harassment</li>
        <li>Discrimination</li>
        <li>Pay Inequity</li>
        <li>Wage & Hour violations</li>
        <li>Unpaid Time & Overtime</li>
      </ul>
      
      <p><strong>Employer-Side Advice & Planning:</strong></p>
      <ul>
        <li>Recruitment & Advertising</li>
        <li>OnBoarding & Hire</li>
        <li>E-Verify & I-9</li>
        <li>Personnel Files</li>
        <li>Family Medical Leave Act</li>
        <li>Americans With Disabilities Act</li>
        <li>Employee Manual Drafts & Review</li>
        <li>Management and Harassment Training</li>
      </ul>
    </>
  )
},
  
  {
  question: "Labor Law",
  number: "02",
  content: (
    <>
      <p><strong>Labor Law:</strong></p>
      <ul>
        <li>Unfair Labor Practices</li>
        <li>Collective Bargaining Negotiations</li>
        <li>Grievance Investigation & Response</li>
      </ul>
    </>
  )
},{
  question: "Training",
  number: "03",
  content: (
    <>
      <p><strong>Training:</strong></p>
      <ul>
        <li>Harassment & Discrimination Training</li>
        <li>Management Best Practices</li>
        <li>Human Resources Policy & Procedure</li>
        <li>Internal Investigations</li>
        <li>Whistleblower Protection</li>
        <li>Management to Employee Communications</li>
      </ul>
    </>
  )
}
  ];
  const navigate= useNavigate()
  const toContact =()=>{
    navigate("/contact")
  }

  return (
    <div>
       <helmet>
        <title>James McCanna | Employment & Labor Law Attorney</title>
        <meta
          name="description"
          content="Employment law attorney James McCanna helps workers & employers with fair treatment, compliance & workplace issues. Free consultation."
        />
      </helmet>
        <div className="floatBtn">
            <button onClick={()=>( window.location.href = "tel:+13602974057")}>Call Now</button>
        </div>
        <div className= {`floatNav ${menuActive ? "floatNavActive":""}`} >
            <Fonav />
        </div>
      <div className="IntroPage">
        <nav>
          <Nav />
        </nav>
        <div className="introWrap">
          <h2>Practice Areas</h2>
          <img src={underline} alt="" />
        </div>
      </div>
      
      <div className="practiceSection">
        <div className="prominiAccordion">
          <div className="accordion">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq ${activeIndex === index ? "active" : ""}`}
              >
                <div className="question" onClick={() => toggleFAQ(index)}>
                <div className="queestionNumber">
                <span>{faq.number}</span>

                </div>
                <div className="faqQuizWrap">
                  <span>{faq.question}</span>
                  <Icon className="faIcon" icon="solar:alt-arrow-up-line-duotone" />
                </div>
                 
                </div>
                <div className="answer">
                  {faq.content}
                </div>
              </div>
            ))}
          </div>
          <button onClick={()=>toContact()}>Contact Me Today</button>
        </div>
      </div>
      <footer>
        <FooterComp />
      </footer>
    </div>
  );
}

export default Practice;